<template>
  <div v-if="member">
    <!-- header start -->
    <van-nav-bar
      title="个人信息"
      right-text="保存"
      fixed
      :z-index="99"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <van-cell-group>
      <!-- 头像上传 start -->
      <van-uploader
        :after-read="onRead"
        extensions="jpg,gif,png"
        class="avatar-uploader"
      >
        <div class="avatar">
          <van-image width="100%" height="100%" fit="cover" round :src="img" />
          <van-icon name="add-o" class="addBtn" />
        </div>
        <P class="t12 c7">账号: {{ member.No }}</P>
      </van-uploader>
      <!-- 头像上传 end -->
      <!-- vueCropper 剪裁图片实现 start-->
      <van-popup v-model="isShowCropper">
        <div class="vue-cropper-box" v-if="isShowCropper">
          <div class="vue-cropper-content">
            <vueCropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.outputSize"
              :outputType="option.outputType"
              :info="option.info"
              :canScale="option.canScale"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
            ></vueCropper>
          </div>
          <span @click="isShowCropper = false" class="clearBtn">取消</span>
          <span
            v-if="isShowCropper"
            type="danger"
            @click="onCubeImg"
            class="submitBtn"
            >确认</span
          >
        </div>
      </van-popup>
      <!-- vueCropper 剪裁图片实现 end-->
    </van-cell-group>

    <van-cell-group>
      <van-field
        v-model="member.NickName"
        label="昵称:"
        input-align="right"
        placeholder="请输入昵称"
      />
      <van-field
        v-model="member.RealName"
        label="姓名:"
        input-align="right"
        placeholder="请输入真实姓名"
      />
    </van-cell-group>

    <van-cell-group>
      <van-field
        v-model="selectSex"
        type="text"
        label="性别:"
        placeholder="请选择性别"
        input-align="right"
        readonly
        is-link
        @click="selectSexShow = true"
      />
      <van-field
        v-model="areaListInput"
        label="地区"
        placeholder="选择省 / 市 / 区"
        input-align="right"
        is-link
        @click="showArea"
      />
    </van-cell-group>

    <van-cell-group>
      <van-field
        v-model="member.ContactPhone"
        placeholder="请输入手机号码"
        type="tel"
        label="手机:"
        input-align="right"
      />
      <van-field
        v-model="member.Email"
        placeholder="请输入邮箱"
        type="email"
        label="邮箱:"
        input-align="right"
      />
      <van-field
        v-model="member.ParentId"
        placeholder="请输入父级编号"
        type="ParentId"
        label="父级编号:"
        input-align="right"
        :disabled="
          member.ParentId != null && member.ParentId != '' && !isFirst
            ? true
            : false
        "
      />
    </van-cell-group>

    <!-- 性别选择 popup start -->
    <van-popup v-model="selectSexShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="['男', '女']"
        cancel-button-text
        confirm-button-text="确定"
        :visible-item-count="3"
        :default-index="member.Gender != null ? member.Gender - 1 : 0"
        @confirm="onConfirmSex"
        @cancel="selectSexShow = false"
      />
      <!-- @change="onSexChange" -->
    </van-popup>
    <!-- 性别选择 popup end -->
    <!-- 选择省 / 市 / 区 popup start -->
    <van-popup v-model="arealistShow" :lazy-render="false" position="bottom">
      <!-- <van-area
        :area-list="areaList"
        :columns-num="3"
        value="110101"
        @confirm="arealistShow = false"
        @cancel="arealistShow = false"
        @change="onAreaListChange"
      /> -->
      <van-picker
        ref="area"
        show-toolbar
        :columns="columns"
        @cancel="arealistShow = false"
        @confirm="onConfirmArea"
      />
    </van-popup>
    <!-- 选择省 / 市 / 区 popup end -->
  </div>
</template>

<script>
import { Toast } from "vant";
import { VueCropper } from "vue-cropper";
import AreaList from "@/assets/js/area";
export default {
  data() {
    return {
      //裁剪组件的基础配置option
      option: {
        img: "", //裁剪图片的地址
        info: true, //裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "jpeg", //裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 160, // 默认生成截图框宽度
        autoCropHeight: 160, // 默认生成截图框高度
        fixed: true, //是否开启截图框宽高固定比例
        fixedNumber: [4, 4], //截图框的宽高比例
      },
      isShowCropper: false, //是否显示截图框
      fileUpload: null,
      fileinfo: {},
      form: {},
      img: "https://img.yzcdn.cn/vant/cat.jpeg",

      nickname: "爱无止境",
      realname: "张三",

      selectSex: "",
      selectSexShow: false,

      arealistShow: false,
      areaList: AreaList,
      areaListInput: "",

      tel: "",
      email: "",
      member: null,
      columns: null,
      defaultAreaIndex: null,
      isFirst: true,
    };
  },
  components: {
    VueCropper,
  },
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      var that = this;
      if (
        that.member.NickName == "" ||
        that.member.NickName == null ||
        that.member.NickName.trim().length == 0
      ) {
        Toast("请输入昵称");
        return;
      }
      this.$store
        .dispatch({
          type: "GetMemberUpdateMemberVue",
          NickName: that.member.NickName,
          RealName: that.member.RealName,
          Gender: that.member.Gender,
          AreaIds: that.member.AreaIds,
          ContactPhone: that.member.ContactPhone,
          Email: that.member.Email,
          HeadPic: that.img,
          ParentId: that.member.ParentId,
        })
        .then(
          (res) => {
            Toast(res.Message);
            //console.log(res, "eeeeeeeeeeee");
            setTimeout(() => {
              if (res.IsSuccess) {
                that.init();
              }
            }, 1000);
          },
          (err) => {}
        );
    },
    //头像上传，传按钮上传成功执行事件
    onRead(file) {
      console.log(file);
      //将原图片显示为选择的图片
      //this.$refs.avatarImg.src = file.content;
      this.option.img = file.content;
      this.isShowCropper = true;
    },

    // 确定裁剪图片
    onCubeImg() {
      var that = this;
      // 获取cropper的截图的base64 数据
      this.$refs.cropper.getCropData((data) => {
        this.fileinfo.url = data;
        this.isShowCropper = false;

        that.img = data;

        //先将显示图片地址清空，防止重复显示
        this.option.img = "";

        //将剪裁后base64的图片转化为file格式
        // let file = this.convertBase64UrlToBlob(data)
        // file.name = this.fileUpload.name

        //将剪裁后的图片执行上传
        // this.uploadFile(file).then(res => {
        //   this.form.content = res.file_id    //将上传的文件id赋值给表单from的content
        // })
      });
    },

    // 将base64的图片转换为file文件
    convertBase64UrlToBlob(urlData) {
      let bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      let ab = new ArrayBuffer(bytes.length);
      let ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], { type: "image/jpeg" });
    },

    onSexChange(picker, value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
      this.selectSex = value;
    },
    onConfirmSex(v, index) {
      this.selectSex = v;
      this.selectSexShow = false;
      this.member.Gender = index + 1;
    },
    /*选择省 / 市 / 区*/
    onAreaListChange(picker) {
      var areaValue = picker.getValues();
      this.areaListInput =
        areaValue[0].name +
        " / " +
        areaValue[1].name +
        " / " +
        areaValue[2].name;
    },
    // 地区
    onConfirmArea(value, indexs) {
      this.defaultAreaIndex = indexs;
      this.arealistShow = false;
      this.areaListInput = value[0] + value[1] + value[2];
      this.member.AreaIds =
        "~3716~" +
        this.columns[indexs[0]].id +
        "~" +
        this.columns[indexs[0]].children[indexs[1]].id +
        "~" +
        this.columns[indexs[0]].children[indexs[1]].children[indexs[2]].id +
        "~";
    },
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetAreasListVue",
        })
        .then(
          (res) => {
            res.map((e) => {
              e.children.map((c) => {
                if (!c.children) {
                  c.children = Object.assign(
                    [],
                    [
                      {
                        children: null,
                        id: "-1",
                        text: "",
                      },
                    ]
                  );
                }
              });
            });
            that.columns = res;
          },
          (error) => {}
        );
      this.$store
        .dispatch({
          type: "GetMemberMemberInfoAreaIndex",
        })
        .then(
          (res) => {
            // console.log(res);
            that.member = res.Member;
            that.img = that.member.HeadPic;
            if (that.member.ParentId != null && that.member.ParentId != "") {
              that.isFirst = false;
            }
            this.areaListInput =
              that.member.AreaName != null ? that.member.AreaName : "";
            that.selectSex =
              that.member.Gender != null
                ? that.member.Gender == 1
                  ? "男"
                  : "女"
                : "";
            that.defaultAreaIndex = res.AreaIndexList;
          },
          (err) => {}
        );
    },
    showArea() {
      this.arealistShow = true;
      this.$refs.area.setIndexes(this.defaultAreaIndex);
    },
  },
  created() {
    var that = this;
    this.init();
  },
};
</script>

<style scoped>
/*头像裁剪上传*/
.avatar-uploader {
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 15px;
}
.avatar-uploader .avatar {
  width: 86px;
  height: 86px;
  border-radius: 50%;
  border: 3px solid #b3b3b3;
  position: relative;
  margin: 6px auto;
}
.avatar-uploader .addBtn {
  position: absolute;
  bottom: -5px;
  right: -2px;
  font-size: 24px;
  color: #999;
}
.vue-cropper-box {
  width: 100vw;
  height: 100vh;
  position: relative;
  z-index: 99;
}
.vue-cropper-content {
  width: 100vw;
  height: 100vh;
}
.vue-cropper {
  background: #000;
}
.cropper-view-box {
  border-radius: 50%;
}
.vue-cropper-box .clearBtn {
  position: absolute;
  bottom: 28px;
  left: 28px;
  font-size: 30px;
  color: #fff;
  padding: 10px 20px;
}
.vue-cropper-box .submitBtn {
  position: absolute;
  bottom: 28px;
  right: 28px;
  font-size: 30px;
  color: #fff;
  padding: 10px 20px;
}
</style>
